import React from "react";
import "./Product_Info_Card.css";
import Green_Outline_Btn from "../common_btn/green_outline_btn/Green_Outline_Btn";
import Best_seller_heart from "../product_card/Best_seller_heart/Best_seller_heart";
import Add_to_card_btn from "../common_btn/Add_to_card_btn/Add_to_card_btn";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import { useSelector } from "react-redux";

const Product_Info_Card = ({
  id,
  imgSrc,
  vdoSrc,
  productName,
  priceText,
  mrp,
  product,
  fromSubCategory,
  categoryId,
  subcategoryId,
}) => {
  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  // const productColors = product?.colors || [
  //   "#868080",
  //   "#ffffff",
  //   "#e9d79d",
  //   "#e2c0c4",
  // ];

  // const productColors =
  //   product?.Product_Variants?.map((variant) => ({
  //     id: variant.id,
  //     name: variant?.Metal?.name,
  //   })) || [];

  const colorMap = {
    // Neutral
    Black: "#000000",
    White: "#FFFFFF",
    Grey: "#C3B6A9",
    Gray: "#808080",
    LightGrey: "#D3D3D3",
    DarkGrey: "#A9A9A9",
    Charcoal: "#36454F",
    Ash: "#B2BEB5",
    Smoke: "#738276",
    Stone: "#928E85",
    Graphite: "#383838",

    // Red Family
    Red: "#FF0000",
    DarkRed: "#8B0000",
    // Maroon: "#800000",
    Burgundy: "#800020",
    Wine: "#722F37",
    Crimson: "#DC143C",
    Scarlet: "#FF2400",
    Cherry: "#DE3163",
    Ruby: "#E0115F",

    // Pink Family
    BabyPink: "#F4C2C2",
    LightPink: "#FFB6C1",
    HotPink: "#FF69B4",
    BlushPink: "#FE828C",
    DustyPink: "#D8A7B1",
    RosePink: "#FF66CC",
    Salmon: "#FA8072",
    Coral: "#FF7F50",

    // Orange Family
    Orange: "#FFA500",
    BurntOrange: "#CC5500",
    Apricot: "#FBCEB1",
    Rust: "#B7410E",
    Terracotta: "#E2725B",

    // Yellow Family

    Mustard: "#FFDB58",
    Lemon: "#FFF44F",
    GoldenYellow: "#FFDF00",
    Amber: "#FFBF00",

    // Green Family
    Green: "#008000",
    DarkGreen: "#006400",
    LightGreen: "#90EE90",
    MintGreen: "#98FF98",
    Olive: "#808000",
    OliveGreen: "#556B2F",
    Sage: "#9CAF88",
    Pistachio: "#93C572",
    Emerald: "#50C878",
    BottleGreen: "#006A4E",
    ForestGreen: "#228B22",
    SeaGreen: "#2E8B57",
    Lime: "#32CD32",

    // Blue Family
    Blue: "#0000FF",
    Navy: "#000080",
    NavyBlue: "#000080",
    SkyBlue: "#87CEEB",
    LightBlue: "#ADD8E6",
    RoyalBlue: "#4169E1",
    SteelBlue: "#4682B4",
    Denim: "#1560BD",
    Aqua: "#00FFFF",
    Cyan: "#00FFFF",
    Teal: "#008080",
    Turquoise: "#40E0D0",

    "Indigo Blue": "#AFC8FF",
    Peach: "#FFE5D4",
    Maroon: "#D8A7B1",
    blue: "#ADD8E6",
    Grey: "#D3D3D3",
    beige: "#F5F5DC",
    White: "#FFFFFF",
    "Charcoal Grey": "#C4C9CF",
    Mauve: "#EFD8FF",
    "Nude Pink": "#F6D7D2",
    "Dark Brown": "#C9A68A",
    Yellow: "#FFF59D",
    Mint: "#D8FFE1",
    Cream: "#FFFDE7",
    "Light Olive": "#D6D8A8",
    "Pastel Blue": "#D6ECF5",
    Pink: "#FFDDEB",
    "Muted Olive Green": "#C8D2A3",
    "Muted Brown": "#D7BFAE",
    Taupe: "#D8CEC8",
    "Blush Pink": "#FBE3E8",
    "Dusty pastel Blue": "#D7EAF7",
    "Light sage Green": "#DCE6D1",

    // Purple Family
    Purple: "#800080",
    Lavender: "#E6E6FA",
    Lilac: "#C8A2C8",

    Violet: "#8F00FF",
    Plum: "#8E4585",

    // Brown / Nude Family
    Brown: "#8B4513",
    DarkBrown: "#654321",
    Chocolate: "#7B3F00",
    Coffee: "#6F4E37",
    Camel: "#C19A6B",
    Tan: "#D2B48C",
    Khaki: "#C3B091",
    Beige: "#F5F5DC",
    Ivory: "#FFFFF0",
    OffWhite: "#FAF9F6",
    PearlWhite: "#F8F6F0",
    Nude: "#E3BC9A",
    Skin: "#F1C27D",
    Sand: "#C2B280",
    Mocha: "#967969",
    Almond: "#EED9C4",
    Champagne: "#F7E7CE",

    // Metallic
    Gold: "#D4AF37",
    RoseGold: "#B76E79",
    Silver: "#C0C0C0",
    Copper: "#B87333",
    Bronze: "#CD7F32",
    Platinum: "#E5E4E2",

    // Fashion Colors
    Magenta: "#FF00FF",
    Fuchsia: "#FF00FF",
    Indigo: "#4B0082",
    Periwinkle: "#CCCCFF",
    NeonPink: "#FF10F0",
    NeonGreen: "#39FF14",
    NeonYellow: "#FFFF33",
    NeonOrange: "#FF5F1F",
    NeonBlue: "#1F51FF",

    // Common Apparel Variants
    Multi: "linear-gradient(90deg,#ff4d4d,#ffd700,#32cd32,#1e90ff,#800080)",
    Multicolor:
      "linear-gradient(90deg,#ff4d4d,#ffd700,#32cd32,#1e90ff,#800080)",
    Floral: "#E91E63",
    Printed: "#9E9E9E",
    Checks: "#616161",
    Stripes: "#757575",
  };

  const colorAliases = {
    // Grey / Gray
    "Charcoal Grey": "Charcoal",
    "Charcoal Gray": "Charcoal",
    "Dark Grey": "DarkGrey",
    "Dark Gray": "DarkGrey",
    "Light Grey": "LightGrey",
    "Light Gray": "LightGrey",

    // Olive
    "Olive Green": "OliveGreen",
    "Muted Olive": "Muted Olive Green",
    "Olive-Green": "OliveGreen",

    // Navy
    Navy: "NavyBlue",
    "Navy Blue": "NavyBlue",

    // Blues
    "Sky Blue": "SkyBlue",
    "Light Blue": "LightBlue",
    "Royal Blue": "RoyalBlue",
    "Steel Blue": "SteelBlue",

    // Greens
    "Bottle Green": "BottleGreen",
    "Forest Green": "ForestGreen",
    "Sea Green": "SeaGreen",
    "Mint Green": "MintGreen",
    "Light Green": "LightGreen",
    "Dark Green": "DarkGreen",

    // Browns
    "Dark Brown": "DarkBrown",
    "Coffee Brown": "Coffee",
    "Chocolate Brown": "Chocolate",

    // Pinks
    "Baby Pink": "BabyPink",
    "Hot Pink": "HotPink",
    "Light Pink": "LightPink",
    "Dusty Pink": "DustyPink",
    "Rose Pink": "RosePink",
    "Blush Pink": "BlushPink",

    // Purples
    "Light Purple": "Lavender",
    "Light Violet": "Lavender",

    // Metallic
    "Rose Gold": "RoseGold",

    // White
    "Off White": "OffWhite",
    "Pearl White": "PearlWhite",
    "Cream White": "CreamWhite",

    // Nude
    "Skin Colour": "Skin",
    "Skin Color": "Skin",
    "Skin Tone": "Skin",
    "Skin Colour Beige": "Skin",

    // Multi
    Multicolour: "Multicolor",
    "Multi Colour": "Multicolor",
    "Multi-Colour": "Multicolor",
    "Multi Color": "Multicolor",
    "Multi-Color": "Multicolor",
    Multi: "Multicolor",

    // Prints
    FloralPrint: "Floral",
    "Floral Print": "Floral",
    PrintedFabric: "Printed",
    "Printed Fabric": "Printed",
    Checked: "Checks",
    Check: "Checks",
    Striped: "Stripes",

    // Neon
    "Neon Pink": "NeonPink",
    "Neon Green": "NeonGreen",
    "Neon Yellow": "NeonYellow",
    "Neon Orange": "NeonOrange",
    "Neon Blue": "NeonBlue",

    // Common spelling mistakes
    Greay: "Grey",
    Gery: "Grey",
    Gry: "Grey",
    Balck: "Black",
    Whtie: "White",
    Creme: "Cream",
    Beigh: "Beige",
    Purpul: "Purple",
    Yelow: "Yellow",
    Oragne: "Orange",
    Brwon: "Brown",
    Choclate: "Chocolate",
  };

  const productColors = [
    ...new Map(
      (product?.Product_Variants || []).map((variant) => [
        variant?.Metal?.name,
        variant,
      ]),
    ).values(),
  ];

  // Size values - don't render color circles for these
  const sizeValues = new Set([
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
    "XXXL",
    "4XL",
    "5XL",
    "6XL",
    "7XL",
    "8XL",
    "FREE",
    "FREE SIZE",
    "ONESIZE",
    "ONE SIZE",
  ]);

  const isColorProduct = (product?.Product_Variants || []).some((variant) => {
    const value = variant?.Metal?.name?.trim()?.toUpperCase();
    return value && !sizeValues.has(value);
  });

  return (
    <div className="Product_Info_Card">
      {/* <Link to={`/product-details/${encodeId(product?.id)}`}> */}
      <Link
        to={`/product-details/${encodeId(product?.id)}`}
        state={{
          fromSubCategory,
          categoryId,
          subcategoryId,
        }}
      >
        <div className="prod_img_holder">
          <img src={imgSrc} className="prod_img" alt={productName} />

          <video
            className="prod_video"
            src={vdoSrc}
            muted
            loop
            playsInline
            autoPlay
          />
        </div>
      </Link>

      <div className="best_seller_heart_holder">
        <Best_seller_heart product={product} />
      </div>

      <div className="content_holder">
        <div className="middle_div">
          {/* <Link to={`/product-details/${encodeId(product?.id)}`}> */}
          <Link
            to={`/product-details/${encodeId(product?.id)}`}
            state={{
              fromSubCategory,
              categoryId,
              subcategoryId,
            }}
          >
            <p className="prod_name">{productName}</p>
          </Link>
          <div className="price_div">
            <p className="mrp_text">
              {symbol} {Number(mrp * rate).toFixed(2)}
            </p>
            <p className="s_price_text">
              {symbol} {Number(priceText * rate).toFixed(2)}
            </p>
          </div>
        </div>

        {/* <div className="product_colors">
          {productColors.map((color, index) => (
            <span
              key={index}
              className="color_circle"
              style={{ backgroundColor: color }}
            ></span>
          ))}
        </div> */}

        <div className="product_colors">
          {isColorProduct &&
            product?.Product_Variants?.map((variant) => {
              const metalName = variant?.Metal?.name?.trim() || "";
              const colorName = colorAliases[metalName] || metalName;
              const colorCode = colorMap[colorName] || "#D3D3D3";

              return (
                <span
                  key={variant.id}
                  className="color_circle"
                  style={{
                    background:
                      colorName === "Multicolor" || colorName === "Multi"
                        ? colorCode
                        : undefined,
                    backgroundColor:
                      colorName === "Multicolor" || colorName === "Multi"
                        ? undefined
                        : colorCode,
                  }}
                  title={metalName}
                />
              );
            })}
        </div>

        <div className="btn_holder">
          <Add_to_card_btn id={product?.id} product={product} />
        </div>
      </div>
    </div>
  );
};

export default Product_Info_Card;
